export const categories = [
  {
    id: 'fruit-candy',
    name: '水果糖果',
    slug: 'fruit-candy',
    description: '天然水果风味，酸甜可口，每一颗都充满阳光的味道',
    image: 'https://readdy.ai/api/search-image?query=Vibrant%20colorful%20fruit%20flavored%20candies%20in%20various%20shapes%2C%20orange%20lemon%20strawberry%20grape%20flavors%2C%20arranged%20on%20white%20background%2C%20bright%20natural%20lighting%2C%20professional%20food%20photography%2C%20clean%20minimal%20composition%2C%20sweet%20and%20fresh%20aesthetic&width=600&height=400&seq=candy-cat-fruit&orientation=landscape',
    count: 48,
  },
  {
    id: 'chocolate-candy',
    name: '巧克力糖果',
    slug: 'chocolate-candy',
    description: '丝滑醇厚的巧克力，精选优质可可，带来极致的味蕾享受',
    image: 'https://readdy.ai/api/search-image?query=Assorted%20luxury%20chocolate%20candies%20with%20cocoa%20powder%20dusting%2C%20dark%20milk%20and%20white%20chocolate%20varieties%2C%20elegant%20arrangement%20on%20marble%20surface%2C%20soft%20warm%20lighting%2C%20professional%20gourmet%20food%20photography%2C%20rich%20brown%20tones&width=600&height=400&seq=candy-cat-chocolate&orientation=landscape',
    count: 36,
  },
  {
    id: 'gummy-candy',
    name: '软糖',
    slug: 'gummy-candy',
    description: 'Q弹有嚼劲，造型可爱多样，大人小孩都爱不释手',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20gummy%20bears%20and%20gummy%20candies%20in%20various%20shapes%20and%20colors%2C%20translucent%20texture%2C%20scattered%20on%20bright%20white%20surface%2C%20cheerful%20and%20playful%20composition%2C%20macro%20food%20photography%2C%20vivid%20colors%20with%20soft%20shadows&width=600&height=400&seq=candy-cat-gummy&orientation=landscape',
    count: 52,
  },
  {
    id: 'lollipop',
    name: '棒棒糖',
    slug: 'lollipop',
    description: '经典童年味道，缤纷色彩螺旋纹路，甜蜜随身携带',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20swirl%20lollipops%20in%20various%20sizes%20standing%20upright%2C%20rainbow%20spiral%20patterns%2C%20bright%20and%20cheerful%20display%20against%20clean%20white%20backdrop%2C%20professional%20product%20photography%2C%20vivid%20colors%2C%20playful%20and%20nostalgic&width=600&height=400&seq=candy-cat-lollipop&orientation=landscape',
    count: 28,
  },
  {
    id: 'gift-box',
    name: '糖果礼盒',
    slug: 'gift-box',
    description: '精美包装，馈赠佳品，用甜蜜传递心意与祝福',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20candy%20gift%20boxes%20with%20beautiful%20ribbon%20packaging%2C%20assorted%20premium%20sweets%20visible%20through%20transparent%20window%2C%20luxurious%20presentation%20on%20soft%20pastel%20background%2C%20professional%20product%20photography%2C%20gift%20giving%20concept%2C%20warm%20and%20inviting&width=600&height=400&seq=candy-cat-giftbox&orientation=landscape',
    count: 24,
  },
  {
    id: 'bulk-candy',
    name: '散装糖果',
    slug: 'bulk-candy',
    description: '量大实惠，品质保证，满足批发采购和派对活动需求',
    image: 'https://readdy.ai/api/search-image?query=Large%20quantity%20of%20colorful%20assorted%20bulk%20candies%20in%20glass%20jars%20and%20containers%2C%20candy%20buffet%20display%2C%20party%20candy%20setup%2C%20bright%20and%20abundant%20arrangement%2C%20clean%20white%20background%2C%20professional%20commercial%20photography&width=600&height=400&seq=candy-cat-bulk&orientation=landscape',
    count: 60,
  },
];

export const getCategoryBySlug = (slug: string) => {
  return categories.find((c) => c.slug === slug);
};